import React, { useState, useEffect, forwardRef } from 'react';
import '../css/Navigation.css';
import SelectRole from './SelectRole';
import SelectTodo from './SelectTodo';
import PromptExampleArea from './PromptExampleArea';
import ShowAnalysisStep from './ShowAnalysisStep';

const Navigation = forwardRef(({ navigationExamples, navigationState, updateNavigationState }, ref) => {
  const [role, setRole] = useState(navigationState.role || false);
  const [selectedTodo, setSelectedTodo] = useState(navigationState.selectedTodo || null);
  const [selectedTodoStep, setSelectedTodoStep] = useState(navigationState.selectedTodoStep || null);
  const [showAnalysisStep, setShowAnalysisStep] = useState(navigationState.showAnalysisStep || false);
  const [showPrompt, setShowPrompt] = useState(navigationState.showPrompt || false);
  const [showAnalysisPrompt, setShowAnalysisPrompt] = useState(navigationState.showAnalysisPrompt || false);
  const [selectedStep, setSelectedStep] = useState(navigationState.selectedStep || null); // selectedStepの状態を保持

  useEffect(() => {
    // ナビゲーションの状態を保存する
    updateNavigationState({
      role,
      selectedTodo,
      selectedTodoStep,
      showAnalysisStep,
      showPrompt,
      showAnalysisPrompt,
      selectedStep, // selectedStepも保存
    });
  }, [role, selectedTodo, selectedTodoStep, showAnalysisStep, showPrompt, showAnalysisPrompt, selectedStep, updateNavigationState]);

  const clickShowAnalysis = () => {
    setShowAnalysisStep(true);
    setShowPrompt(false);
  };

  const clickTodo = (todo) => {
    setSelectedTodo(todo);
    setShowPrompt(true);
    setShowAnalysisPrompt(false);
    setShowAnalysisStep(false);
  };

  const clickAnalysisStep = (todoStep) => {
    setShowAnalysisPrompt(true);
    setSelectedTodoStep(todoStep);
  };

  const handleStepClick = (step) => {
    setSelectedStep(step); // selectedStepを更新
  };

  return (
    <div className="chat-area" ref={ref}>
      <div className="chat-message assistant-message">
        <div className="message-sender">
          <img src="/img/chat_logo.png" alt="Profile Picture" className="icon h-[25px] w-[25px]" />
          <p className="prompt-help-introduction">プロンプトの例をご紹介します</p>
        </div>
        <div className="add-prompt-area">
          <SelectRole setRole={setRole} />
          {role && <SelectTodo selectedTodo={selectedTodo} onButtonClick={clickTodo} />}
          {showAnalysisStep && <ShowAnalysisStep todo={selectedTodo} onButtonClicked={clickAnalysisStep} onStepClick={handleStepClick} selectedStep={selectedStep} />}
          {showPrompt && <PromptExampleArea role={role} todo={selectedTodo} navigationExamples={navigationExamples} clickShowAnalysis={clickShowAnalysis} />}
          {showAnalysisPrompt && <PromptExampleArea role="all" todo={selectedTodoStep} navigationExamples={navigationExamples} clickShowAnalysis={clickShowAnalysis} />}
        </div>
      </div>
    </div>
  );
});

export default Navigation;
